import { render, staticRenderFns } from "./CompareGalleryView.vue?vue&type=template&id=1d374df6&scoped=true&"
import script from "./CompareGalleryView.vue?vue&type=script&lang=js&"
export * from "./CompareGalleryView.vue?vue&type=script&lang=js&"
import style0 from "./CompareGalleryView.vue?vue&type=style&index=0&id=1d374df6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d374df6",
  null
  
)

export default component.exports